
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';


export class CorreoApi {
    
    static mensaje(mensaje, token ) {          
      let mensajeEnvio = Object.assign({}, mensaje);
		let comando="POST";
		
		mensajeEnvio=JSON.stringify(mensajeEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/correo/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: mensajeEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
}